import { connect } from 'react-redux'
import { getProjects } from 'actions/overview_actions'

export default connect(state => {
  return {
    projectGroups: state.overview?.projectGroups || [],
    mspWorkflows: state.overview?.mspWorkflows || [],
    projects: state.overview?.projects || []
  }
}, { getProjects })
